import axios from '../shared/axios';
import * as events from './events';

export function getContractPrograms(companyid, projectid, contractid, accessibleWfIds) {
    return axios.post(`/api/Program/LoadProgramsList`, { accessibleWfIds }, { params: { companyid, projectid, contractid } });
}

export function getProgram(programid) {
    return axios.get(`/api/Program/GetProgram?programid=${programid}`);
}

export function saveContractProgram(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/Program/SaveProgram`, data)
            .then(result => {
                events.onNotification_CREATED();
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function updateProgram(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/Program/Update`, data)
            .then(result => {
                switch (data.actioncode) {
                    case 'SAVE_DRAFT':
                        events.onNotification_DRAFT_SAVED();
                        break;
                    case 'COMMUNICATE':
                        events.onNotification_COMMUNICATED();
                        break;
                    case 'REPLY_DRAFT':
                        events.onNotification_REPLY_DRAFT_SAVED();
                        break;
                    case 'REPLY_SEND':
                        events.onNotification_REPLY_SENT();
                        break;
                    default:
                        alert('Unknown action code!');
                        break;
                }
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function deleteProgramDraft(programid) {
    new Promise((resolve, reject) => {
        return axios.post(`api/Program/DeleteDraft?programid=${programid}`)
            .then(result => {
                events.onNotification_DELETED();
                resolve(result);
            })
            .catch(error => reject(error));
    })
}

export function importPrograms(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/Program/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deleteProgramDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/Program/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicateProgramDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/Program/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}